// growthos/warchest-frontend/react-app/src/Components/v2/atoms/ActivityItems/shared/StyledComponents.tsx
import styled from "styled-components";

export const ActivityItemWrapper = styled("div")`
  display: flex;
  align-items: flex-start;
  padding: 12px 0px;
  gap: 12px;
`;

export const ActivityDate = styled("span")`
  font-size: 12px;
  color: #757575;
`;

export const IconWrapper = styled("div")`
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
`;

export const IconContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
`;
